import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';

class ReportsMenu extends Component {

    constructor() {
        super();
        if (!Comm.ValidSession())
            return;

        this.state = {
            Translation: Translation
        };
    }



    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;



        return (

            <div className="btn-toolbar">
                {
                    Context.HasRight("rwarehousequery") &&
                    <Link className="btn btn-primary menuButton" to='/warehousequery'>
                        <i className="fa fa-cubes"></i>
                        <p>{Translation.Trans("production")}</p>
                    </Link>
                }
                {
                    Context.HasRight("rsalesreport") &&
                    <Link className="btn btn-primary menuButton" to='/salesreport'>
                        <i className="far fa-money-bill-alt"></i>
                        <p>{Translation.Trans("sales")}</p>
                    </Link>
                }

                {
                    Context.HasRight("rdeliveriesreport") &&

                    <Link className="btn btn-primary menuButton" to='/deliveriesreport'>
                        <i className="fas fa-truck"></i>
                        <p>{Translation.Trans("deliveries")}</p>
                    </Link>
                }

                {
                    Context.HasRight("rcorrections") &&
                    <Link className="btn btn-primary menuButton" to='/corrections'>
                        <i className="fas fa-boxes"></i>
                        <p>{Translation.Trans("editedquantities")}</p>
                    </Link>
                }

                {
                    Context.HasRight("rbarcodesreport") &&
                    <Link className="btn btn-primary menuButton" to='/barcodereport'>
                        <i className="fas fa-boxes"></i>
                        <p>{Translation.Trans("barcodereport")}</p>
                    </Link>
                }

                

            </div>


        );
    }

}


export default ReportsMenu;


// WEBPACK FOOTER //
// ./src/pages/reportsmenu.js